import { LogOut, Menu, Wallet } from 'lucide-react'
import { useAuth } from '../../contexts/AuthContext'
import { truncateAddress } from '../../lib/utils'

interface HeaderProps {
  onMenuClick: () => void
}

export default function Header({ onMenuClick }: HeaderProps) {
  const { address, logout } = useAuth()

  return (
    <header className="h-16 bg-slate-900 border-b border-slate-800 flex items-center justify-between px-4 md:px-6">
      <div className="flex items-center gap-3">
        {/* Mobile menu button */}
        <button
          onClick={onMenuClick}
          className="lg:hidden p-2 text-slate-400 hover:text-white transition-colors"
        >
          <Menu size={24} />
        </button>
        <h2 className="text-base md:text-lg font-semibold text-white">Revenue Dashboard</h2>
      </div>

      <div className="flex items-center gap-2 md:gap-4">
        {/* Connected Wallet */}
        <div className="flex items-center gap-2 bg-slate-800 rounded-lg px-2 md:px-4 py-2">
          <Wallet size={16} className="text-doge-400" />
          <span className="text-xs md:text-sm text-slate-300 font-mono hidden sm:inline">
            {address ? truncateAddress(address) : 'Not connected'}
          </span>
          <div className="w-2 h-2 bg-green-400 rounded-full" />
        </div>

        {/* Logout Button */}
        <button
          onClick={logout}
          className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors p-2"
          title="Logout"
        >
          <LogOut size={20} />
        </button>
      </div>
    </header>
  )
}
